<template>
  <div>
    <!-- <el-pagination
        background
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="currentPage"
        :page-sizes="[10, 15, 20]"
        layout="total, sizes, prev, pager, next, jumper"
        class=""
        :total="total"
        :pager-count="5"
      /> -->
     <div style="display: flex;flex-direction: row-reverse;margin: 20px 0;">
       <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="currentPage"        :page-size="pageSize" :total="total" />
     </div>
  </div>
  </div>
</template>

<script>
  export default {
    name: "commonTable",
    props: {
      total: {
        //总条数
        type: Number,
        default: 0,
      },
      pageSize: {
        type: Number,
        default: 0,
      },
      currentPage: {
        //当前页数
        type: Number,
        default: 1,
      },

      loading: {
        //表格加载
        type: Boolean,
        default: false,
      },

      handleSizeChange: {
        //监听切换条数
        type: Function,
        default: () => {},
      },

      handleCurrentChange: {
        type: Function,
        default: () => {},
      },

      handleSelectionChange: {
        type: Function,
        default: () => {},
      },
      handleClickRow: {
        type: Function,
        default: () => {},
      },
    },
    data() {
      return {
        computedClearName: [
          'demandProtuctsCheck',
        ]
      };
    },
    methods: {
      /**@method 监听切换条数并调用父组件方法 */
      sizeChange(val) {
        console.log(val)
        this.$emit("handleSizeChange", val);
        /*  handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        } */
      },
      /**@method 监听下一页并调用父组件方法 */
      currentChange(val) {
        this.$emit("handleCurrentChange", val);
        /* handleCurrentChange(val) {
          console.log(`当前页: ${val}`);
        } */
      },
    },
  };
</script>

<style scoped>
.el-pagination {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/common/commonTable.vue